// src/components/DentalNewsTicker.jsx
import { useState, useEffect } from "react";

const FALLBACK_NEWS = [
  { title: "Latest advances in digital dentistry transforming clinical practice", source: "Digital Dentistry", url: "https://news.digital-dentistry.org" },
  { title: "New guidelines for infection control in dental settings released by DCI", source: "Dental Tribune", url: "https://www.dental-tribune.com" },
  { title: "AI-powered diagnostics improving early detection of oral cancer", source: "Dentistry Today", url: "https://www.dentistrytoday.com" },
  { title: "Minimally invasive dentistry gaining traction among Indian practitioners", source: "Oral Health Group", url: "https://www.oralhealthgroup.com" },
  { title: "Study links periodontal disease to cardiovascular complications", source: "Dental Daily Brief", url: "https://dentaldailybrief.com" },
  { title: "DCI releases updated curriculum guidelines for dental colleges 2024", source: "Dental Reach", url: "https://dentalreach.today" },
  { title: "Implant success rates improve with new nano-surface technology", source: "Dental Good News", url: "https://www.dentalgoodnews.com" },
  { title: "Continuing education requirements updated for dental professionals", source: "Dentistry Newsletters", url: "https://dentistrynewsletters.com" },
];

export default function DentalNewsTicker({ sidebarMode = false }) {
  const [news, setNews] = useState(FALLBACK_NEWS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        // Using rss2json to convert Dentistry Today feed to JSON
        const response = await fetch(
          "https://api.rss2json.com/v1/api.json?rss_url=https://www.dentistrytoday.com/feed/"
        );
        const data = await response.json();

        if (data.items && data.items.length > 0) {
          const liveNews = data.items.map(item => ({
            title: item.title,
            source: data.feed.title || "Dentistry Today",
            url: item.link
          }));
          setNews(liveNews);
        }
      } catch (error) {
        console.error("Failed to fetch dental news:", error);
        // Fallback to static news if fetch fails
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
    
    // Refresh news every 30 minutes
    const interval = setInterval(fetchNews, 30 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Duplicate news for seamless loop
  const tickerItems = [...news, ...news];

  if (sidebarMode) {
    return (
      <div style={{ height: "100%", width: "100%", overflow: "hidden", display: "flex", flexDirection: "column" }}>
        {/* Header with LIVE badge */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "4px 8px 8px 8px", borderBottom: `1px solid rgba(37,99,235,0.1)` }}>
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <span style={{ width: 6, height: 6, background: "#dc2626", borderRadius: "50%", display: "inline-block", animation: "sidebarpulse 1.2s infinite" }} />
            <span style={{ color: "#dc2626", fontWeight: 900, fontSize: 13, letterSpacing: 0.5 }}>LIVE NEWS</span>
          </div>
          <span style={{ color: "#94a3b8", fontWeight: 800, fontSize: 13 }}>🦷 FEED</span>
        </div>

        {/* Scrolling Ticker */}
        <div style={{ flex: 1, position: "relative", overflow: "hidden", display: "flex", alignItems: "center" }}>
          <div style={{ display: "flex", animation: "dentalticker 40s linear infinite", whiteSpace: "nowrap" }}>
            {tickerItems.slice(0, 10).map((item, i) => (
              <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6, paddingRight: 32 }}>
                <span style={{ color: "#2563eb", fontSize: 16 }}>•</span>
                <a href={item.url} target="_blank" rel="noreferrer"
                  style={{ color: "#1e293b", fontSize: 14, fontWeight: 700, textDecoration: "none", whiteSpace: "nowrap" }}>
                  {item.title}
                </a>
              </span>
            ))}
          </div>
        </div>

        <style>{`
          @keyframes sidebarpulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.5; transform: scale(0.8); }
          }
          @keyframes dentalticker {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: 20 }}>

      {/* Scrolling Ticker */}
      <div style={{ background: "linear-gradient(135deg,#0f2557,#1d4ed8)", borderRadius: 12, overflow: "hidden", boxShadow: "0 4px 16px rgba(15,37,87,0.15)", display: "flex", alignItems: "center", height: 42 }}>

        {/* LIVE badge */}
        <div style={{ background: "#dc2626", height: 42, padding: "0 14px", display: "flex", alignItems: "center", gap: 6, flexShrink: 0, zIndex: 2 }}>
          <span style={{ width: 7, height: 7, background: "#fff", borderRadius: "50%", display: "inline-block", animation: "dentalpulse 1.2s infinite" }} />
          <span style={{ color: "#fff", fontWeight: 900, fontSize: 13, letterSpacing: 1.5 }}>LIVE</span>
        </div>

        {/* Dental News label */}
        <div style={{ background: "rgba(0,0,0,0.2)", height: 42, padding: "0 12px", display: "flex", alignItems: "center", flexShrink: 0, borderRight: "1px solid rgba(255,255,255,0.1)" }}>
          <span style={{ color: "#93c5fd", fontWeight: 800, fontSize: 13, whiteSpace: "nowrap" }}>🦷 DENTAL NEWS</span>
        </div>

        {/* Marquee */}
        <div style={{ flex: 1, overflow: "hidden", position: "relative" }}>
          <div style={{ display: "flex", animation: "dentalticker 100s linear infinite", whiteSpace: "nowrap" }}>
            {tickerItems.map((item, i) => (
              <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 6, paddingRight: 48 }}>
                <span style={{ color: "#fbbf24", fontSize: 14, flexShrink: 0 }}>◆</span>
                <a href={item.url} target="_blank" rel="noreferrer"
                  style={{ color: "#fff", fontSize: 15, fontWeight: 500, textDecoration: "none", whiteSpace: "nowrap" }}
                  onMouseEnter={e => e.currentTarget.style.color = "#fbbf24"}
                  onMouseLeave={e => e.currentTarget.style.color = "#fff"}>
                  {item.title}
                </a>
                <span style={{ color: "#93c5fd", fontSize: 13, fontWeight: 700, flexShrink: 0 }}>— {item.source}</span>
              </span>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes dentalpulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.3; transform: scale(0.7); }
        }
        @keyframes dentalticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes dentalticker:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}
